import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCloseIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M29.737 32 18.068 20.331l2.263-2.262L32 29.737 43.668 18.07l2.263 2.262L34.262 32l11.67 11.669-2.264 2.263L32 34.262 20.33 45.933l-2.263-2.263z"
    />
  </svg>
)
export default SvgCloseIcon
